import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {QbReceivePaymentDto} from "../../model/QbReceivePaymentDto";
import {AuthorizeNetTransactionDto} from "../../model/AuthorizeNetTransactionDto";

export default class UnlinkedTransactionController implements Ng1Controller {
    private error: any;
    private payments: QbReceivePaymentDto[] = [];
    private transactions: AuthorizeNetTransactionDto[] = [];

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.onConnected(this.refresh)
        $dataHub.client.bindAllReceivePayment(() => this.payments);
        $dataHub.client.bindAllAuthorizeNetTransaction(() => this.transactions);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        // load data or something
        this.$dataHub.server.paymentUnlinkedTransactionSub();
    };
    save = (txn: AuthorizeNetTransactionDto, pmt: QbReceivePaymentDto) => {
        this.$dataHub.server.paymentUnlinkedTransactionUpdate(txn, pmt)
            .then(() => {
                this.transactions.remove(txn, x => x.guid);
                this.payments.remove(pmt, x => x.guid);
            })
            .catch(e => alert(e));
    };
}
